// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCjjUlPqZDT6ea05EjUIW6SjLSfLnIyzWE',
    authDomain: 'eneza-loans-dev.firebaseapp.com',
    databaseURL: 'https://eneza-loans-dev.firebaseio.com',
    projectId: 'eneza-loans-dev',
    storageBucket: 'eneza-loans-dev.appspot.com',
    messagingSenderId: '733911134177',
    appId: '1:733911134177:web:46d92091fc3ee8e4112ca0',
    measurementId: 'G-6F7GC4H5JL'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
